import React from 'react';
import { Typography } from '@mui/material';
import { CellDefaultProps } from '../../../types';
import moment from 'moment';
import { DateFormats } from '../../../../../constants/common';

export const DateCell = ({ proposal }: CellDefaultProps) => {
  return (
    <Typography component="span" variant="body2">
      {moment(proposal.createdDateTime).format(DateFormats.DateTimeShort24Hour)}
    </Typography>
  );
};
